import axios from '@axios'

export default {
  namespaced: true,
  state: {
    layouts: [],
    userLayouts: []
  },
  getters: {
    getUserLayouts(state) {
      return state.userLayouts.map((layout) => ({
        id: layout.id,
        name: layout.name,
        grid: layout.data,
        isCard: layout.is_card,
        distance: layout.distance,
      }));
    },
    getItems(state) {
      return state.layouts.map((layout) => ({
        value: layout.id,
        label: layout.name,
      }));
    }
  },
  mutations: {
    setLayouts(state, value) {
      state.layouts = value;
    },
    setUserLayouts(state, value) {
      state.userLayouts = value;
    },
    updateLayout(state, layout) {
      const index = state.layouts.findIndex(l => l.id === layout.id);
      if (index !== -1) {
        state.layouts.splice(index, 1, layout);
      }

      const userIndex = state.userLayouts.findIndex(l => l.id === layout.id);
      if (userIndex !== -1) {
        state.userLayouts.splice(userIndex, 1, layout);
      }
    },
    addLayout(state, layout) {
      state.layouts.push(layout);
      state.userLayouts.push(layout);
    }
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/layout', { params })
      commit('setLayouts', data.data);

      if (!data.success) {
        return [];
      }

      return data;
    },

    async getLayouts({ commit }, params) {
      const { data } = await axios.get('v1/layout', { params })
      commit('setLayouts', data.data);

      if (!data.success) {
        return [];
      }

      return data;
    },

    async getUserLayouts({ commit }, params) {
      const _params = {
        max: 1000,
        ...params
      };
      const { data } = await axios.get('v1/layout', { params: _params })
      // Normalizar usuarios en cada layout para evitar duplicados/formatos mixtos
      const normalized = (data.data || []).map((layout) => {
        if (Array.isArray(layout.users)) {
          const seen = new Set();
          layout.users = layout.users.filter(u => {
            const id = typeof u === 'object' && u !== null ? u.id : u;
            if (id === null || id === undefined) return false;
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
          });
        }
        return layout;
      });
      commit('setUserLayouts', normalized);

      if (!data.success) {
        return [];
      }

      return data;
    },

    async getLayout({ commit }, id) {
      const { data } = await axios.get(`v1/layout/${id}`)

      if (!data.success) {
        return [];
      }

      return data;
    },

    async delete(_, id) {
      const { data } = await axios.delete(`v1/layout/${id}`)

      return data
    },
    async saveLayout({ commit, dispatch, state }, layoutData) {
      try {
        // Normalizar usuarios (aceptar ids o objetos) y deduplicar
        const normalizeUsers = (users) => {
          const arr = Array.isArray(users) ? users : [];
          const ids = arr.map((u) => (typeof u === 'object' && u !== null ? u.id : u)).filter((v) => v !== null && v !== undefined);
          return Array.from(new Set(ids));
        };

        const formattedData = {
          name: layoutData.name,
          data: layoutData.data,
          users: normalizeUsers(layoutData.users),
          id_tenant: layoutData.id_tenant,
          is_default: layoutData.is_default || false,
          is_card: layoutData.is_card || false,
          distance: layoutData.distance || 0
        };
        let response;

        // If we should update
        if (layoutData.updateCurrent && layoutData.layout_id) {
          response = await axios.put(`v1/layout/${layoutData.layout_id}`, formattedData);
          if (response.data && response.data.data) {
            // Deduplicar usuarios también en la respuesta
            const resp = response.data.data;
            if (Array.isArray(resp.users)) {
              const seen = new Set();
              resp.users = resp.users.filter(u => {
                const id = typeof u === 'object' && u !== null ? u.id : u;
                if (seen.has(id)) return false;
                seen.add(id);
                return true;
              });
            }
            commit('updateLayout', resp);
          }
        } else {
          // Create a new layout
          response = await axios.post('v1/layout', formattedData);
          if (response.data && response.data.data) {
            const resp = response.data.data;
            if (Array.isArray(resp.users)) {
              const seen = new Set();
              resp.users = resp.users.filter(u => {
                const id = typeof u === 'object' && u !== null ? u.id : u;
                if (seen.has(id)) return false;
                seen.add(id);
                return true;
              });
            }
            commit('addLayout', resp);
          }
        }

        await dispatch('getUserLayouts');
        return {
          status: true,
          data: response.data.data,
          message: response.data.message || "Operation successful"
        };
      } catch (error) {
        console.error('Error saving layout:', error);
        return {
          status: false,
          data: null,
          error: error.response?.data?.message || error.message || "Unknown error"
        };
      }
    },
    clear({ commit }) {
      commit('setLayouts', [])
      commit('setUserLayouts', [])
    }
  }
}
